import {defineStore} from "pinia";
import {crossbarStore} from "./crossbar";
import { socketStore } from "./socket";

export const demobedStore = defineStore("demobed", {
    state: () => ({
        shopId: -1,
        status: [],
        initDone: false,
        loading: true
    }),

    getters: {
        socketConnected() {
            return socketStore().isConnected;
        },

        isInShop() {
            return crossbarStore().isInShop;
        }
    },

    actions: {
        init() {
            if (!this.initDone) {
                this.initDone = true;

                if (crossbarStore().connected) {
                    this.onCrossbarConnected();
                } else {
                    crossbarStore().on("connected", () => this.onCrossbarConnected());
                }

                socketStore().on("demobed-command", data => this.onStatusMessage(data));
                this.getStatus();
            }
        },

        onCrossbarConnected() {
            crossbarStore().onMessage("demobed-command-" + this.shopId, data => this.onStatusMessage(data));
            this.getStatus();
        },

        getStatus() {
            if (socketStore().isConnected) {
                socketStore().emit("getDemoBedStatus");

            } else if (this.isInShop) {

                crossbarStore().publishToDemoBed("getStatus", this.shopId);
            }
            this.loading = false;
        },

        sendSupportLevel(msg) {
            if (socketStore().isConnected) {
                socketStore().emit("setSupportLevel", msg);
            } else if (this.isInShop) {
                crossbarStore().publishToDemoBed("setSupportLevel", this.shopId, msg);
            }
        },

        onStatusMessage(msg) {
            console.log("onStatusMessage", msg);
            if (msg.command === "status") {

                // sort by bedId which is a string
                const status = msg.data;
                status.sort((a, b) => a.bedId.localeCompare(b.bedId));
                this.status = status;
            }
        }
    }
});